/*   */

import React, { useRef } from "react";
import { connect } from "react-redux";
import objectPath from "object-path";
import Brand from "../brand/Brand";
import Topbar from "./Topbar/Topbar";
//import AnimateLoading from "../../../app/partials/layout/AnimateLoading";
import * as builder from "../../ducks/builder";

const Header = ({
  headerContainerClasses,
  headerAttributes,
  headerClasses,
  walletSidebar,
  setter,
  usdBalance,
  history,
}) => {
  const headerCommonRef = useRef(null);
  return (
    <div
      className={`kt-header kt-grid__item ${headerClasses}`}
      id="kt_header"
      {...headerAttributes}
      ref={headerCommonRef}
    >
      {/* <AnimateLoading /> */}
      <div className="kt-header__top">
        <div
          className={`kt-container kt-container__width ${headerContainerClasses}`}
        >
          <Brand />
          <Topbar
            history={history}
            walletSidebar={walletSidebar}
            usdBalance={usdBalance}
            setter={setter}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  headerClasses: builder.selectors.getClasses(store, {
    path: "header",
    toString: true,
  }),
  headerAttributes: builder.selectors.getAttributes(store, { path: "header" }),
  headerContainerClasses: builder.selectors.getClasses(store, {
    path: "header_container",
    toString: true,
  }),
  menuHeaderDisplay: objectPath.get(
    store.builder.layoutConfig,
    "header.menu.self.display"
  ),
  headerFixedEnabled: objectPath.get(
    store.builder.layoutConfig,
    "header.self.fixed.desktop.enabled"
  ),
  headerFixedDesktop: objectPath.get(
    store.builder.layoutConfig,
    "header.self.fixed.desktop"
  ),
});

export default connect(mapStateToProps)(Header);
